import { graphql } from 'react-apollo';
import gql from 'graphql-tag';
import { compose } from 'recompose';

import queryMetaHandler from '../../../utils/queryMetaHandler';
import omitProps from '../../../utils/omitProps';
import { querySelector } from '../../../utils';
import { APPROVED, UNAPPROVED } from '../constants';

const ODDROWCOLOR = '#FFFFFF';
const EVENROWCOLOR = '#BFBFBF';

export const GetAllUserMonthBonus = gql`
  query GetAllUserMonthBonusQuery($bonusMonth: String! $districtId: Int, $departmentId: Int, $monthBonusState: UserMonthBonusStateTypes ) {
    all_user_month_bonuses(month: $bonusMonth, district_id: $districtId, department_id: $departmentId, state: $monthBonusState) {
      edges {
        node {
          id
          state
          manager_notes
          month_bonus {
            month {
              display
              iso8601
            }
          }
          user {
            id
            fullname
            active
            supervisor {
              id
            }
          }
          district {
            id
            name
          }
          department {
            id
            name
          }
          total_bonus_opportunity
          approved_bonus_amount
          final_bonus_amount
          final_notes
          total_per_diem_amount
        }
      }
    }
  }
`;

const handleRowColor = (previousColor, previousItem, currentItem) => {
  if (!previousColor) {
    return EVENROWCOLOR;
  }
  if (previousItem.user.id === currentItem.user.id) {
    return previousColor;
  }
  return (previousColor === EVENROWCOLOR) ? ODDROWCOLOR : EVENROWCOLOR;
};

const marshallData = ({ data, ownProps }) => {
  const tempResults = querySelector(data, '$.all_user_month_bonuses.edges[*].node', []);

  let previousColor = null;

  const allUsersMonthBonuses = tempResults.map((item, index) => {
    const previousIndex = (index === 0) ? index : index - 1;
    const tempObject = Object.assign({}, item);
    const { state } = item;
    /* NOTE: if user is active, populate final bonus and notes to approved values
    * if user is terminated, set amount and notes to 0 and terminated */
    if (item.user.active) {
      if (state === UNAPPROVED) {
        tempObject.final_bonus_amount = null;
      } else if (state === APPROVED) {
        tempObject.final_bonus_amount = item.approved_bonus_amount;
        tempObject.final_notes = item.manager_notes;
      }
    } else {
      /* NOTE: default terminated values */
      tempObject.final_bonus_amount = 0;
      tempObject.final_notes = 'terminated';
    }
    tempObject.color = handleRowColor(previousColor, tempResults[previousIndex], item);
    previousColor = tempObject.color;
    return tempObject;
  });

  return {
    ...ownProps,
    data,
    allUsersMonthBonuses,
  };
};


const queryGetAllUserMonthBonusData = graphql(GetAllUserMonthBonus, {
  props: marshallData,
});

export const queryGetAllUserMonthBonusGQL = compose(
  queryGetAllUserMonthBonusData,
  queryMetaHandler,
  omitProps(['data']),
);
